var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallGloveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park:boxing"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2066 20.0908V23.4392C21.2066 24.0531 20.71 24.5554 20.0905 24.5554H9.48723C8.87335 24.5554 8.37109 24.0587 8.37109 23.4392V20.0908",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.13889 8.37116V5.58082C6.13889 3.73155 7.63803 2.23242 9.48729 2.23242H15.626H21.2067C23.056 2.23242 24.5551 3.73155 24.5551 5.58082V16.7422C24.5551 18.5914 23.0594 20.0906 21.21 20.0906C17.2817 20.0906 10.9716 20.0906 8.37116 20.0906C4.46469 20.0906 2.23242 15.626 2.23242 12.8357C2.23242 10.0454 2.23242 8.37116 2.23242 8.37116H6.13889Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.13867 7.81348V12.278",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGloveIcon);
export default __webpack_public_path__ + "static/media/smallGloveIcon.fa72a940e6e95089d732c56f1cd99df7.svg";
export { ForwardRef as ReactComponent };